<template>
<div>
    <b-card title="منو جدید">
        <b-card-text>
            <div>
                <b-form @submit="onSubmit" v-if="show">
                    <b-row>
                        <b-col>
                            <b-form-group id="input-group-2" label="عنوان منو:" label-for="input-2">
                                <b-form-input id="input-2" v-model="form.title" required placeholder="عنوان منو"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group id="input-group-2" label="آدرس منو:" label-for="input-2">
                                <b-form-input id="input-2" v-model="form.url" required placeholder="آدرس منو"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group id="input-group-3" label="ایکن منو:" label-for="input-3">
                                <b-form-input id="input-3" v-model="form.icon" required placeholder="ایکن منو"></b-form-input>
                            </b-form-group>
                        </b-col>
                         </b-row>
                          <b-row>
                        <b-col>
                            <b-form-group id="input-group-4" label="ترتیب نمایش:" label-for="input-4">
                                <b-form-input id="input-4" v-model="form.row_order" required placeholder="ترتیب نمایش"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                <b-form-group
                  id="input-group-4"
                  label="منوی والد:"
                  label-for="input-4"
                >
                  <treeselect
                    v-model="form.parent_id"
                    :options="options"
                      :normalizer="normalizer"
                      placeholder="لطفا انتخاب کنید"
                  />
                </b-form-group>
              </b-col>
               <b-col>
                    </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-table responsive striped :items="form.roles" :fields="RoleFields">
                                <template v-slot:cell(on_list)="data">
                                    <b-form-checkbox v-model="data.item.on_list"></b-form-checkbox>
                                </template>
                                <template v-slot:cell(on_create)="data">
                                    <b-form-checkbox v-model="data.item.on_create"></b-form-checkbox>
                                </template>
                                <template v-slot:cell(on_edit)="data">
                                    <b-form-checkbox v-model="data.item.on_edit"></b-form-checkbox>
                                </template>
                                <template v-slot:cell(on_delete)="data">
                                    <b-form-checkbox v-model="data.item.on_delete"></b-form-checkbox>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>

                    <b-button type="submit" variant="primary">ذخیره</b-button>
                    <b-button href="#/rp/4" variant="danger">بازگشت</b-button>
                </b-form>
            </div>
        </b-card-text>
    </b-card>
</div>
</template>

<script>
import {
    SET_BREADCRUMB
} from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
    name: "addUser",
     components: {
    Treeselect,
  },
    data() {
        return {
            form: {
                title: "",
                url: "",
                icon: "",
                role_id: 0,
                row_order: 0,
                roles: [],
                        parent_id: null,

            },
            roles: [],
            options:[],
            show: true,
            RoleFields: [{
                    key: "name",
                    label: "عنوان"
                },
                {
                    key: "on_list",
                    label: "نمایش لیست"
                },
                {
                    key: "on_create",
                    label: "جدید"
                },
                {
                    key: "on_edit",
                    label: "ویرایش"
                },
                {
                    key: "on_delete",
                    label: "حذف"
                }
            ]
        };
    },
    created() {
        httpHelpoer.getData("menu/" + this.$route.params.id).then(res => {
            var data = res.result;
            this.form = {
                id: data.id,
                title: data.title,
                url: data.url,
                icon: data.icon,
                row_order: data.row_order,
                parent_id: data.parent_id,
                roles: data.roles.map(element => {
                    return {
                        id: element.id,
                        name: element.rolename,
                        on_list: element.on_list == 1,
                        on_create: element.on_create == 1,
                        on_edit: element.on_edit == 1,
                        on_delete: element.on_delete == 1
                    };
                })
            };
        });
            this.getTreeMenu();

    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();
            httpHelper.setAuth();
            httpHelper.postData("menu", this.form).then(res => {
                this.$router.push("/rp/4");
            });
        },
            getTreeMenu() {
      httpHelper.setAuth();

      httpHelpoer
        .getData("gettreemenu")
       .then((res) => {
        this.options = res.result.map((element) => {
            if(element.children.length) {
          return {
            id: element.id,
            title: element.title,
            children: element.children,

          };
            }else {
                 return {
            id: element.id,
            title: element.title,
          };
            }
        });
      })
      .finally(() => {});
    },
     normalizer(node) {
      return {
        id: node.id,
        label: node.title,
      }
    },
    },

     mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست منوها",
        route: "/rp/4",
      },
      {
        title: "ویرایش منوها",
      },
    ]);
  },
};
</script>
